import { debounce } from 'throttle-debounce';
import { SETTINGS } from '../../utils/constants';
import getLocalePrefix from '../../lib/getLocalePrefix';

const initSearch = () => {
  const predictiveSearchEls = document.querySelectorAll('[data-predictive-search]');
  if (!predictiveSearchEls.length) return;

  predictiveSearchEls.forEach(search => {
    const searchInputEl = search.querySelector('input[type="search"]');
    const resultsEl = search.querySelector('[data-predictive-search-results]');
    if (!searchInputEl || !resultsEl) return;

    const closeSearchEl = search.querySelector('[data-close-search]');
    const settings = JSON.parse(search.dataset.settings);
    const openResults = () => {
      resultsEl.classList.remove('hidden');
      if (closeSearchEl) closeSearchEl.classList.remove('hidden');
    };

    const closeResults = () => {
      resultsEl.classList.add('hidden');
      if (closeSearchEl) closeSearchEl.classList.add('hidden');
    };

    const fetchResults = async (query) => {
      const localePrefix = getLocalePrefix();
      const url = `${window.location.origin}${localePrefix}/search/suggest?q=${encodeURIComponent(query)}&resources[type]=query,${settings?.type}&resources[options][fields]=${settings?.fields}&resources[limit]=${settings?.limit}&resources[limit_scope]=each&resources[options][unavailable_products]=${settings?.oos}&section_id=predictive-search`;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          closeResults();
          throw new Error(`Fetch failed: ${response.status}`);
        }

        const htmlText = await response.text();
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const section = html.querySelector('#shopify-section-predictive-search');

        if (section) {
          resultsEl.innerHTML = section.innerHTML;

          const noResultsEl = resultsEl.querySelector('[data-no-results]');
          const resultsContentEl = resultsEl.querySelector('[data-search-results-content]');
          if (noResultsEl && resultsContentEl) {
            const hasResults = parseInt(resultsContentEl.dataset.resultsCount, 10) > 0;
            noResultsEl.classList.toggle('hidden', hasResults);
            noResultsEl.classList.toggle('flex', !hasResults);
          }
          
          if (settings?.search_bar === 'header') {
            typeof window.ReloadSmartWishlist === 'function' ? await window.ReloadSmartWishlist() : null;
            typeof window.yotpoWidgetsContainer === 'object' && typeof window.yotpoWidgetsContainer.initWidgets === 'function' ? await window.yotpoWidgetsContainer.initWidgets() : null;
          }
          openResults();
        } else {
          closeResults();
        }
      } catch (error) {
        closeResults();
        console.error('Search error:', error);
      }
    };

    const handleInput = () => {
      const value = searchInputEl.value.trim();
      if (value.length <= settings?.trigger - 1) {
        closeResults();
        return;
      }
      fetchResults(value);
    };
    const debouncedHandleInput = debounce(SETTINGS.SEARCH_DEBOUNCE_DELAY, handleInput);
    searchInputEl.addEventListener('input', debouncedHandleInput);

    searchInputEl.addEventListener('focus', () => {
      search.classList.add('is-search-active');
    });
    
    searchInputEl.addEventListener('blur', () => {
      search.classList.remove('is-search-active');
    });

    if (closeSearchEl) {
      closeSearchEl.addEventListener('click', () => {
        searchInputEl.value = '';
        resultsEl.innerHTML = '';
        closeResults();
      });
    }

    const controller = new AbortController();
    document.addEventListener('click', (event) => {
      if (!search.contains(event.target)) {
        searchInputEl.value = '';
        resultsEl.innerHTML = '';
        closeResults();
      }
    }, { signal: controller.signal });
  });
  window.theme.search = { initSearch };
};

const initAdvancedCommerceSearch = () => {
  const advancedCommerceEl = document.querySelector('[data-acs-autocomplete]');
  if (!advancedCommerceEl) return;

  const closeSearchEl = document.querySelector('[data-close-search]');
  const overlayEl = document.querySelector('[data-search-overlay]');

  if (advancedCommerceEl._acsObserver) {
    advancedCommerceEl._acsObserver.disconnect();
  }

  const observer = new MutationObserver(() => {
    const display = getComputedStyle(advancedCommerceEl).display;
    if (display === 'block') {
      if (overlayEl) overlayEl.classList.add('!block');
      if (closeSearchEl) closeSearchEl.classList.remove('hidden');
    } else {
      if (overlayEl) overlayEl.classList.remove('!block');
      if (closeSearchEl) closeSearchEl.classList.add('hidden');
    }
  });

  advancedCommerceEl._acsObserver = observer;

  observer.observe(advancedCommerceEl, {
    attributes: true,
    attributeFilter: ['style', 'class']
  });

};

export { initSearch, initAdvancedCommerceSearch };
